export default function ProgressBar({
  value,
  max = 100,
  showLabel = true,
  color = 'bg-game-primary',
  height = 'h-3',
  className = '',
}) {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));

  return (
    <div className={`w-full ${className}`}>
      <div className={`w-full ${height} bg-[#2a2d31] rounded-full overflow-hidden`}>
        <div
          className={`${height} ${color} rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <div className="mt-1 text-xs text-game-text-dim text-right">
          {value} / {max}
        </div>
      )}
    </div>
  );
}
